// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__ByuUq","errors":"Errors_errors__2P2ym"};